import {Component, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {UserService} from '../../services/user.service';
import { Location } from '@angular/common';

@Component({
    selector: 'app-forgot-password-page',
    templateUrl: './forgot-password-page.component.html',
    styleUrls: ['./forgot-password-page.component.css'],
    standalone: false
})
export class ForgotPasswordPageComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  submitted: boolean = false;
  loading: boolean = false;
  user: any;
  passwordResetSuccess: boolean = false;


  constructor(private formBuilder: FormBuilder,
              private toastr: ToastrService,
              private userService: UserService,
              private router: Router,
              private location: Location) {
  }

  ngOnInit() {
    this.initializeForm();
  }

  initializeForm(): void {
    this.form = this.formBuilder.group(
      {
        email: [
          '',
          [Validators.required]
        ]
      }
    );
  }

  onClickSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      this.toastr.error('Please enter registered email', 'Reset password failed');
      return;
    }

    const {email} = this.form.value;

    this.loading = true;
    this.userService.resetPassword(email).subscribe(
      {
        next: (data) => {
          this.loading = false;
          if (data.status == 'SUCCESS') {
            this.passwordResetSuccess = true;
            // this.router.navigate(['/docs']);
            this.toastr.success('Password reset successfully', 'Success');
          } else {
            this.toastr.error('We do not recognize the e-mail address provided', 'Cannot proceed with password reset');
          }
        },
        error: (err) => {
          this.loading = false;
          this.toastr.error('We do not recognize the e-mail address provided', 'Cannot proceed with password reset');
        }
      }
    );
  }

  get formControl(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  goBack(): void {
    this.location.back();
  }

}
